export default 'generic';
